import { useTranslation } from "@/core/i18n";
import { BlockingModal } from "organisms/blocking-modal/BlockingModal";

interface DisputeInProgressModalProps {
  open: boolean;
  platformName: string;
  contactPhone?: string | null;
  contactEmail?: string | null;
  showSwitchLocations: boolean;
  onSwitchLocations: () => void;
}

export const DisputeInProgressModal = ({ platformName, ...props }: DisputeInProgressModalProps) => {
  const { t } = useTranslation();
  return (
    <BlockingModal
      {...props}
      title={t("disputeInProgressModal.title")}
      description={<p>{t("disputeInProgressModal.description", { platformName })}</p>}
      platformName={platformName}
    />
  );
};
